module.exports = __webpack_public_path__ + "static/media/AdminNómina_Incapacidades.0086bb9b.svg";